module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_7016.9adbfb95.png";